import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort, MatSortable } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import * as _ from 'underscore';
import * as __ from 'lodash';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { HashService } from 'src/app/_services/hash.service';
import { FusionChartsService } from 'src/app/_services/fusion-charts.service';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';
import cjson from 'compressed-json';


@Component({
    selector: 'app-education-tab',
    templateUrl: './education-tab.component.html',
    styleUrls: ['./education-tab.component.scss'],
    standalone: false
})
export class EducationTabComponent implements OnInit {

  constructor(private fusionChartseervice: FusionChartsService,private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService, private localStorageService: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private hashService: HashService) { }
  companyDetails: any;
  currentCompanyName: any;
  school: any = [];
  schoolData: any = [];
  displayedColumns: string[] = ['key', 'doc_count', 'recentGraduate', 'graph'];
  @ViewChild('educationTbSort') schoolsTbSort: MatSort;

  totalResultCount: number = 0;
  startindex: number = 0;
  education: any = [];
  requestObject: any = {};
  fieldOfStudy: any = [];
  aggregatescount: number = 50;
  showSchoolLoader: boolean = true;
  showEducationLoader: boolean = true;
  showFieldOfStudyLoader: boolean = true;
  alternatecompanyNames: any[] = [];

  /** start index in page */
  start: number = 0;
  /**End index in page */
  end: number = 5;
  /**Number of items on each of page */
  pageSize: number = 5;
  /**Current page number */
  currentPage: number = 1;
  /**Total items */
  totalCount = 0;
  educationsubscription: Subscription;
  schoolemptystate: boolean = false;
  qualificationemptystate: Boolean = false;
  fieldofstudyemptystate: Boolean = false;
  /**Recent graduate data */
  recentGraduate: any = [];
  recentGraduatedata: any = [];
  isRecentGraduateData: boolean = false;
  schoolsSortData = [];
  schoolsdataAI: any
  schoolsdata: any = [];
  educationdata: any = []
  fieldofstudydata: any = [];
  /** Subscription var */
  subscriptions: Array<Subscription> = [];
  companyinsightsFilter: any = {};

  insightsExportSubscription: Subscription = null;

  /**
 * Mapping of key and text value of headers
 * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
 */
  tableHeaderObj = {
    "Schools": "Schools",
    "TalentCount": "Talent Count",
    "RecentGraduate": "Recent Graduate",
    "%OfTotal": "% of Total"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  filterData: any;

  ngOnInit(): void {
    this.start = 0;
    this.end = 5;
    this.currentPage = 1;
    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      const eventInfo = _methodDetails;
      // The actual current filter-panel state lives in the getter
      this.filterData = this.filterDataHandlerService.fetchFilterData;
      this.fetchPageData();
    })

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.getSchool();
    this.getEducation();
    this.getFieldOfStudy();
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

  }

  getSchool() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "school";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.considerfilterforaggregates = true;

    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      this.totalResultCount = response.data.totalresultscount;
      this.showSchoolLoader = false;
      const tempData = response.data.aggregations.school;
      this.totalCount = tempData.length;
      this.schoolsSortData = tempData;

      this.recentGraduate = _.pluck(this.schoolsSortData, 'key');
      this.isRecentGraduateData = false;
      this.getRecentGraduate();
      this.manualSort();
      this.schoolemptystate = true;
    }, () => {
      this.showSchoolLoader = false;
    });
  }

  convertToTitleCase(stringName) {
    stringName = stringName.toLowerCase().split(' ');
    for (let i = 0; i < stringName.length; i++) {
      stringName[i] = stringName[i].charAt(0).toUpperCase() + stringName[i].slice(1);
    }
    return stringName.join(' ');
  }

  manualSort() {
    this.reSortArr(this.schoolsTbSort)
  }

  reSortArr(sort) {
    const data = this.schoolsSortData;

    if (!sort || !sort.active || sort.direction === '') {
      this.schoolData = data.slice(this.start, this.end);
      this.school = new MatTableDataSource(this.schoolData);
      this.school.sort = this.schoolsTbSort;
      return;
    }

    this.schoolsSortData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'recentGraduate': return this.compare(a.recentGraduate, b.recentGraduate, isAsc);
        case 'graph': return this.compare(a.doc_count, b.doc_count, isAsc);
      }
    });

    this.schoolData = this.schoolsSortData.slice(this.start, this.end);
    this.school = new MatTableDataSource(this.schoolData);
    this.school.sort = this.schoolsTbSort;
  }

  compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getRecentGraduate() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "recentgraduate-school";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.considerfilterforaggregates = true;

    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations['recentgraduate-school'];
      this.recentGraduatedata = _.pluck(tempData, "doc_count");

      this.schoolsSortData.map(res => {
        const filteredData = tempData.filter(x => x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
        res.recentGraduate = filteredData && filteredData.doc_count ? filteredData.doc_count : 0;
        this.isRecentGraduateData = true;
        return res;
      })
      this.getschoolsaidata(this.schoolsSortData, 'schools')
    })
  }

  getSchoolPercentage(value) {
    return ((value / this.totalResultCount) * 100).toFixed(2);
  }

  getEducation() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "education";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.considerfilterforaggregates = true;

    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const data = response.data.aggregations.education.slice(0, 5);
      this.getschoolsaidata(data, 'educations')
      this.showEducationLoader = false;
      this.qualificationemptystate = true;
      this.education = this.fusionChartseervice.educationChart(data);
    });
  }

  getFieldOfStudy() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "fieldofstudy";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.considerfilterforaggregates = true;

    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const data = response.data.aggregations.fieldofstudy;
      this.getschoolsaidata(data, 'fieldofstudy')
      this.showFieldOfStudyLoader = false;
      const CharForSeniority = [];

      this.fieldOfStudy = this.fusionChartseervice.fieldOfStudyChart(data);
    });
  }

  /**
 * Function set the start and end of aggreggate datat according to page number
 * @param index page number in pagination
 */
  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;

      this.manualSort();

  }

  /**
   * destroy subscriptions of filters
   */
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'education') return;

    // education chart config
    const educationChart = { renderAt: 'education', type: 'column2d', dataSource: __.cloneDeep({ ...this.education }) };
    educationChart['type'] = educationChart['dataSource']['type'];
    delete educationChart?.['dataSource']?.['type'];
    delete educationChart?.['dataSource']?.['width'];
    delete educationChart?.['dataSource']?.['chart']?.['width'];
    delete educationChart?.['dataSource']?.['height'];
    delete educationChart?.['dataSource']?.['chart']?.['height'];
    delete educationChart?.['dataSource']?.['chart']?.['renderAt'];
    educationChart['width'] = '100%';

    // field-of-study chart config
    const fieldOfStudyChart = { renderAt: 'fieldofstudy', dataSource: __.cloneDeep({ ...this.fieldOfStudy })};
    fieldOfStudyChart['type'] = fieldOfStudyChart['dataSource']['type'];
    delete fieldOfStudyChart?.['dataSource']?.['type'];
    delete fieldOfStudyChart?.['dataSource']?.['width'];
    delete fieldOfStudyChart?.['dataSource']?.['chart']?.['width'];
    delete fieldOfStudyChart?.['dataSource']?.['height'];
    delete fieldOfStudyChart?.['dataSource']?.['chart']?.['height'];
    fieldOfStudyChart['dataSource']['chart']['legendPosition'] = 'bottom';
    fieldOfStudyChart['dataSource']['chart']['legendNumColumns'] = '4';
    fieldOfStudyChart['width'] = '100%';

    this.tableHeaderName = [this.tableHeaderObj["Schools"], this.tableHeaderObj["TalentCount"], this.tableHeaderObj["RecentGraduate"], this.tableHeaderObj["%OfTotal"]];

    const payloadForInsightsExport: ExportPayload = {
      tab: 'education',
      companydetails: this.companyDetails,
      totalresultcount: this.totalResultCount,
      chartdetails: [].concat(this.education?.data?.length ? educationChart : []).concat(this.fieldOfStudy?.data?.length ? fieldOfStudyChart : []),
      school: this.schoolsSortData,
      tableHeader: this.tableHeaderName
    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    const redirectFilters: Partial<FilterParams> = {
            // Company context — always present
            companyid: this.companyDetails?.id,
            companyname: this.currentCompanyName,
            alternativecompanynames: this.alternatecompanyNames,

            // Read-only snapshot of the overview tab's OWN filter panel (person-search-filter
            // sidebar). Nested so it can never collide with the listing page's normal filters.
            insightsFilterData: this.filterData,
          };
    switch (type) {
      case 'school': redirectFilters['mandatoryschools'] = [key]; break;
      case 'recentgraduatesonly': {
        redirectFilters['mandatoryschools'] = [key];
        redirectFilters['recentgraduatesonly'] = true;
        break;
      }
    }


  const uniqueKey = this.hashService.generateUniqueHash();
    localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

    const url = `/candidate-list?type=search&redirectSource=company-insights&key=${uniqueKey}`;
    window.open(url, '_blank');
  }

  getschoolsaidata(data, type) {

    if(type == 'schools') {

      this.schoolsdata = data.map(x=>{
        let res: any ={};
        res['Schools'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['Recent Graduate'] = x.recentGraduate;
        res['% of Total'] = this.getSchoolPercentage(x.doc_count)+'%';
        return res;
      })
    } if(type == 'educations') {
      this.educationdata = data.map(x=>{
        let res:any = {};
        res['Qualifications'] = x.key;
        res['Talent Count'] = x.doc_count;
        return res;
      })
    } if(type == 'fieldofstudy') {
      this.fieldofstudydata = data.map(x=>{
        let res:any = {};
        res['Field of Study'] = x.key;
        res['% of Talent Count'] = x.doc_count+'%';
        return res;
      })
    }

    this.schoolsdataAI = {
      schools: this.schoolsdata,
      educations: this.educationdata,
      fieldofstudies: this.fieldofstudydata
    }
    if(this.schoolsdata.length == 0 && this.educationdata.length == 0 && this.fieldofstudydata.length == 0)
      this.schoolsdataAI = null;
   }
}
